'use client'

import { Fragment, type JSX } from 'react'
import { Card } from '@vinted/web-ui'

import { BundleEntryBanner } from '@marketplace-web/bundles/items-bundle-feature'
import { transformUserBundleDiscountDto } from '@marketplace-web/bundles/items-bundle-data'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { ProfileUserDto } from '@marketplace-web/profile/profile-data'

import { isDateInTheFuture } from '../../../../utils/date'

type Props = {
  user: ProfileUserDto | null | undefined
  showBundles: boolean
  userId: number
  renderCountDownBanner: () => JSX.Element | null
}

const ProfileVisitorBanners = ({ user, showBundles, userId, renderCountDownBanner }: Props) => {
  const breakpoints = useBreakpoint()
  const bundlingSellerProfileAbTest = useAbTest('bundling_seller_profile_v2')
  const isBundlingSellerProfileAbTestOn =
    bundlingSellerProfileAbTest?.variant === 'a' || bundlingSellerProfileAbTest?.variant === 'b'

  const { bundle_discount: bundleDiscount, closet_countdown_end_date: closetCountdownEndDate } =
    user || {}

  if (closetCountdownEndDate && isDateInTheFuture(closetCountdownEndDate))
    return renderCountDownBanner()

  if (!showBundles) return null

  const transformedBundleDiscounts = bundleDiscount
    ? transformUserBundleDiscountDto(bundleDiscount)
    : null

  const Wrapper = breakpoints.tabletsUp ? Card : Fragment

  return (
    <Wrapper>
      <BundleEntryBanner
        itemUserId={userId}
        bundleDiscount={transformedBundleDiscounts}
        screen="user_profile"
        showStartBundleButton={!isBundlingSellerProfileAbTestOn}
      />
    </Wrapper>
  )
}

export default ProfileVisitorBanners
